import Job from 'models/Job';
import JobCity from 'models/JobCity';

import { Props as ButtonProps } from 'components/layout/Button';

import Component from './component';

export interface Props {
    job: Job;
    jobCity: JobCity;
    buttonProps: {
        save: ButtonProps;
        share: ButtonProps;
        apply?: ButtonProps;
        applyCvFree?: ButtonProps;
    };
    applicationButtonVisible?: boolean;
    onApply: () => any;
}

Component.defaultProps = {};
export default Component;